const Ajax = require('common/infra/ajax');

class API {
    fetchProjectStatusesByGroup(groupID, inProgress = true, limit = 10, cursor = null) {
        const queries = [];
        queries.push(`in_progress=${inProgress}`);
        queries.push(`limit=${limit}`);
        if (cursor) {
            queries.push(`nextCursor=${cursor}`);
        }
        const query = queries.join('&');
        return Ajax.GET(`/api/groups/${groupID}/project-statuses?${query}`)
    }

    fetchByProject(projectID, options = {}) {
        return Ajax.GET(`/api/projects/${projectID}/project-status`, options);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/project-status.js